class MobileMenuBar extends HTMLElement {
  connectedCallback() {
    const footer = document.querySelector("footer");
    if (!footer) return;
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.style.transform = "translateY(calc(100% + 30px))";
        } else {
          this.style.transform = "";
        }
      },
      { threshold: 0.1 }
    );
    this.observer.observe(footer);
  }
  disconnectedCallback() {
    this.observer?.disconnect();
  }
}
window.customElements.define("mobile-menu-bar", MobileMenuBar);
